module.exports = __webpack_public_path__ + "static/about-insta-2@2x-891abe4c9ae312bf9624b54e8381d04b.jpg";